import APIClient from '@/shared/http/clients/api'

const resourceName = 'pessoas'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAniversariantesPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/aniversariantes/?page=${index}&size=${limit}`, config)
const GetContactsPaging = (order, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/contatados/${order}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const CreateTelefone = (id = {}, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/${id}/telefone/`, data, config)
const CreateEndereco = (id = {}, data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/${id}/endereco/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const GetByDocument = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}`, config)
const GetByName = (name = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?nome=${name}`, config)
const Search = (name = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?${name}&page=${index}&size=${limit}`, config)
const Patch = (data = {}, config = {}) => APIClient.patch(`${APICore}/${resourceName}/${data.id}`, data, config)
const GetAllLastRenovation = (orderBy, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/ultima-renovacao/${orderBy}?page=${index}&size=${limit}`, config)
const VincularExistente = (data = {}, config = {}) => APIClient.post(`${APICore}/deslocamentos/vincular-pessoa-existente`, data, config)

const ManagerRepository = {
  GetAll,
  GetAllPaging,
  GetAniversariantesPaging,
  GetContactsPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  GetByDocument,
  GetByName,
  CreateTelefone,
  CreateEndereco,
  Patch,
  GetAllLastRenovation,
  VincularExistente
}

export default ManagerRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/person.js